import React from 'react'

const Attendance = ({
  attendance  = 0,
  percent     = 0,
  text        = ''
}) => {
  if ( attendance && percent ) {
    percent += '%'
    return (
      <div className="attendance">
        <div className="people">
          <div className="people-all"></div>
          <div className="attendance-bar" style={ { width: percent } }></div>
        </div>
        <span className="percentage">{ percent }</span>
        <div className="capacity">{ text }: { attendance }</div>
      </div>
    )
  } else {
    return (
      <div className="capacity">{ text }: { attendance }</div>
    )
  }
}

const MatchDetails = ({
  coverage    = '',
  venue       = '',
  address     = '',
  attendance  = 0,
  percent     = 0,
  capacity    = 0,
  date        = '',
  text        = {}
}) => {

  return (
    <article className="sub-module game-information">
      <header>
        <h1>{ text.heading || '' }</h1>
      </header>
      <div className="content">
        <div className="game-field">
          {
            venue &&
            <div className="game-details location-details">
              <div className="capacity">{ text.venue || '' }: { venue }</div>
            </div> || null
          }
          <div className="game-details">
            <div className="game-date-time">{ date }</div>
            {
              coverage &&
              <div className="game-network">{ text.coverage || '' }: { coverage }</div> || <div className="game-network"></div>
            }
          </div>
        </div>
        <div className="location-details">
          {
            address &&
            <ul key="location">
              <li className="icon-font-before icon-location-solid-before">{ address }</li>
            </ul> || null
          }
          {
            capacity && capacity !== '0' &&
            <div className="capacity">{ text.capacity || '' }: { capacity }</div> || null
          }
          {
            attendance && attendance !== '0' &&
            <Attendance percent={ percent } attendance={ attendance } text={ text.attendance || '' }/> || null
          }
        </div>
      </div>
    </article>
  )
}

export default MatchDetails



/** WEBPACK FOOTER **
 ** ../app/components/gamepackage/rugby/components/MatchDetails.jsx
 **/